import template from './checkbox-list-field.html';

const CheckboxListFieldComponent = {
    bindings: {
        displayProp: '<',
        hideLabel: '<',
        inputClass: '<',
        label: '<',
        labelClass: '<',
        numColumns: '<',
        options: '<',
    },
    template
};

export default CheckboxListFieldComponent;



// WEBPACK FOOTER //
// ./app/common/form-fields/checkbox-list-field/checkbox-list-field-component.js